export const ScenicViews = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M19 21h1.01c.972 0 1.457 0 1.725-.203a1 1 0 00.395-.737c.02-.335-.25-.74-.788-1.547l-3.01-4.516c-.446-.668-.668-1.002-.949-1.118a1 1 0 00-.766 0c-.28.116-.503.45-.948 1.118l-.744 1.116M19 21L11.316 9.9c-.442-.638-.663-.957-.94-1.07a1 1 0 00-.752 0c-.276.113-.497.432-.94 1.07l-5.946 8.59c-.563.813-.844 1.22-.828 1.557a1 1 0 00.391.747c.27.206.764.206 1.753.206H19zm2-15a3 3 0 11-6 0 3 3 0 016 0z'
        ></path>
      </svg>
    </span>
  );
};
